<template>
    <div class="sub-plans-page">
        <div class="d-flex flex-column w-100">
            <div class="sub-header">
                <div>
                    <span class="head-name">Hedlyner Subscription Plans</span><br />
                    <span class="head-name">for <span class="artist-check">Artist</span></span>
                </div>
                <!-- TODO: remove comments if feature is needed in future
                <div v-if="getPlanName !== 'Pro'">
                    <button class="call-to-action" @click="updateToPro">
                        <span class="call-to-action-text">Become our Development Partner</span>
                    </button>
                </div>
                -->
            </div>
            <!--TODO: remove comments if feature is needed in future
            <div class="d-flex divider my-5"></div>
            <div class="current-plan" v-if="!isAuthed">
                <div>
                    <span class="plan-cond">
                        Sign Up for a free month trial period to unlock more features</span
                    >
                </div>
            </div>
            <div v-if="currentSubscriptionPlan === 'ArtistFree'" class="free-info">
                <div class="your-plan-sub">Your plan</div>
                <div class="plan-name-info" :style="planColor">{{ getPlanName }}</div>
            </div>
            <div v-if="currentSubscriptionPlan !== 'ArtistFree'">
                <div class="subs-rows">
                    <div class="rows-plan">
                        <div class="form-for-plan">
                            <div class="your-plan-sub">Your plan</div>
                            <div class="plan-name-info" :style="planColor">
                                {{ getPlanName }}
                            </div>
                        </div>
                        <div class="form-for-plan">
                            <div class="your-plan-sub">Billing cycle</div>
                            <div class="sub-info">Monthly</div>
                        </div>
                    </div>
                    <div class="rows-plan">
                        <div class="form-for-plan">
                            <div class="your-plan-sub">Trial period</div>
                            <div class="sub-info">
                                {{ proTrialEnds }} {{ infoSubs.trial_ends }}
                            </div>
                        </div>
                        <div class="form-for-plan">
                            <div class="your-plan-sub">Next billing date:</div>
                            <div class="sub-info">{{ infoSubs.next_bill_date }}</div>
                        </div>
                    </div>
                    <div class="rows-plan">
                        <div class="form-for-plan">
                            <div><span class="your-plan-sub">Payment</span></div>
                            <div class="sub-info">${{ infoSubs.monthly_price / 100 }}</div>
                        </div>
                        <div class="form-for-plan">
                            <div class="your-plan-sub">Payment card</div>
                            <div class="sub-info">
                                {{ paymentCard.brand }} {{ paymentCard.last4 }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            -->
        </div>
        <ArtistSubCard
            :isAuthed="isAuthed"
            :plans="plans"
            :currentSubscriptionPlan="currentSubscriptionPlan"
        />
    </div>
</template>

<script>
    import { SubMixin } from '../../mixins/subscription/subscriptions'
    import ArtistSubCard from './parts/ArtistSubCard.vue'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'SubArtistPlan',
        components: { ArtistSubCard },
        mixins: [SubMixin],
        data() {
            return {
                isAuthed: null,
                plans: [],
                currentSubscriptionPlan: '',
                paymentCard: {},
                infoSubs: {}
            }
        },
        methods: {
            async getUserPlan() {
                let response = await axios.get('/profile/stripe/user/get-plan/artist')
                this.currentSubscriptionPlan = response.data.subscription.plan_name
                this.paymentCard = response.data.card
                this.infoSubs = response.data.subscription
            },
            updateToPro() {
                this.showModal()
                this.plan = this.plans.filter((plan) => plan.name === 'ArtistPro')[0]
            },
            async checkAuth() {
                const response = await axios.get('/check-authorization')
                this.isAuthed = response.data.isAuthorized
            },
            async checkSub() {
                const response = await axios.get('/api/profile/stripe/get-plans')
                this.plans = response.data.data
            }
        },
        computed: {
            proTrialEnds() {
                const trialEndsDate = moment(this.infoSubs.trial_ends, 'MMMM DD, YYYY')
                const today = moment()
                return today.isSameOrBefore(trialEndsDate, 'day') ? 'Ends' : 'Ended'
            },
            getPlanName() {
                if (this.currentSubscriptionPlan) {
                    return this.subPlansArtist.filter(
                        (plan) => plan.subscriptionName === this.currentSubscriptionPlan
                    )[0].planName
                } else {
                    return ''
                }
            },
            planColor() {
                return this.getPlanName === 'Basic' ? 'color: #cdeb09' : 'color: #d8b500;'
            }
        },
        async created() {
            await this.checkAuth()
            await this.checkSub()
            await this.getUserPlan()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .sub-info-free {
        color: $lighter-grey;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }
    .free-info {
        @include flex-col;
        align-items: flex-start;
        gap: 16px;
    }
    .sub-info {
        overflow: hidden;
        color: $white-3;
        text-overflow: ellipsis;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }
    .form-for-plan {
        @include flex-col;
        align-items: flex-start;
        gap: 6px;
        flex: 1 0 0;
    }
    .subs-rows {
        @include flex-col;
        align-items: flex-start;
        gap: 24px;
        align-self: stretch;
    }
    .rows-plan {
        @include flex-start;
        gap: 24px;
        align-self: stretch;
    }
    .artist-check {
        color: $lime;
        @include base-font-44;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .sub-plans-page {
        @include flex-col;
        align-items: center;
        padding: 90px 80px;
        gap: 96px;
    }
    .sub-header {
        @include flex-row;
        justify-content: space-between;
        align-items: center;
    }
    .head-name {
        color: $white-2;
        text-align: center;
        @include base-font-44;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .call-to-action {
        display: flex;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 100px;
        background: $lime;
        border: none;
    }
    .call-to-action-text {
        color: $black;
        @include base-font-18;
        font-weight: 650;
        line-height: 120%;
    }
    .divider {
        height: 1px;
        justify-content: center;
        align-items: center;
        align-self: stretch;
        background-color: $grey;
    }
    .current-plan {
        @include flex-col;
        align-items: flex-start;
        gap: 16px;
    }
    .your-plan-sub {
        color: $lighter-grey;
        @include base-font-16;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .plan-name-info {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }
    .plan-cond {
        color: $lighter-grey;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }
    @media screen and (max-width: 980px) {
        .sub-header {
            flex-direction: column !important;
            gap: 20px;
            align-items: flex-start;
        }
        .sub-plans-page {
            padding: 16px;
        }
    }
</style>
